import { IPreviewVoiceRecording, ISharedVoiceRecordingTranscript } from "atlas-shared";
import { download, RestRequest, stream } from "@Utils";
import { checkFlag } from "./featureFlagApi";
import { getAccesToken } from "@Components";

export const downloadVoiceRecordingFilename = (
  organization_id: IPreviewVoiceRecording["organization_id"],
  id: IPreviewVoiceRecording["id"],
  filename: string,
  onError?: (error) => void
) => {
  download(`voice_recording/${organization_id}/${id}/filename`, filename, onError);
};

export const streamVoiceRecordingFilename = (
  organization_id: IPreviewVoiceRecording["organization_id"],
  id: IPreviewVoiceRecording["id"],
  onError?: (error) => void
): Promise<string> => {
  return stream(`voice_recording/${organization_id}/${id}/filename`, onError);
};

export const generateVoiceRecordingTranscript = async (
  organization_id: IPreviewVoiceRecording["organization_id"],
  id: IPreviewVoiceRecording["id"]
) => {
  if (await checkFlag("voice.ari", false)) {
    return fetch(
      process.env.REACT_APP_VOICE_BASE_URL + `/api/v1/voice_recordings/${id}/actions/transcribe`,
      {
        body: JSON.stringify({}),
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + getAccesToken() },
      }
    ).then((v) => v.json());
  } else {
    return RestRequest.post<any, ISharedVoiceRecordingTranscript>(
      `voice_recording/${organization_id}/${id}/transcript`,
      {}
    );
  }
};

export const getVoiceRecordingTranscript = (
  organization_id: IPreviewVoiceRecording["organization_id"],
  id: IPreviewVoiceRecording["id"]
) => {
  return RestRequest.get<ISharedVoiceRecordingTranscript>(
    `voice_recording/${organization_id}/${id}/transcript`
  );
};
